import Wrapper from "../components/Wrapper"
import LazyLoadingPhoto from "../components/LazyLoadingPhoto"

function Home() {
    return (
        <div>
            <Wrapper title={ "Home" }>
            <div>
                <h1>Welcome to Ryan's Upholstery!</h1>
                <p>
                    Ryan's Upholstery in Roseburg, Oregon is a local and small upholstery shop you can rely on. 
                    At Ryan's Upholstery, Ryan provides top quality services for commercial, residential,
                    automotive, and marine applications. Ryan also does repair and replacement work for customers
                    including private party, business owners, restaurants, and furniture stores from tears in
                    fabric to broken down and missing sections of foam. Ryan can repair wood frame work, spring
                    work, foam and upholstery work.
                </p>
                <LazyLoadingPhoto base="front_page"/>
                <p>
                    Give Ryan a call whether your restaurant needs the booths
                    redone or your car has a tear in the seat, you're covered. Call to schedule a time to see
                    the various quality samples of fabric, vinyl, and leather options. You can also fill out a
                    request for a FREE quote today <a href="/quote">here</a>! Ryan looks forward to serving you!
                </p>
            </div>
            </Wrapper>
        </div>
    );
}

export default Home;